<div class="top-bar-wrapper" [ngClass]="{ portrait: rwdService.isSmallDevice }">
  <button class="hamburger-button mat-flat-button" *ngIf="rwdService.isSmallDevice" (click)="showNavigation()">
    <mat-icon class="padded-icon">menu</mat-icon>
  </button>

  <div class="festive-theme">
    <div *ngIf="festiveTheme">
      <ng-container *ngIf="festiveTheme.pattern; else basic">
        <ng-container *ngFor="let el of festiveTheme.pattern.split(';')">
          <span [style]="'color:' + festiveTheme.textColor + ';'" *ngIf="el === 'txt'"> {{ festiveTheme.text }}</span>
          <img *ngIf="el === 'img'" [src]="festiveTheme.image" />
        </ng-container>
      </ng-container>
      <ng-template #basic>
        <span [style]="'color:' + festiveTheme.textColor + ';'">{{ festiveTheme.text }} </span> <img [src]="festiveTheme.image" />
      </ng-template>
    </div>
  </div>

  <div class="spacer"></div>

  <div class="other-actions" *ngIf="!rwdService.isSmallDevice">
    <div *ngIf="showCompanyId" class="font-18 margin-top-10">{{ 'label.firm' | loc }}: "{{ companyDS.peekCompanyId() }}"</div>
    <!-- <div class="tech-break">
      <b> Drodzy Użytkownicy, </b> Informujemy, że w celu zapewnienia jeszcze lepszej jakości naszych usług, przeprowadzimy
      zaplanowane prace konserwacyjne na platformie. <br />
      W związku z tym, nasza
      <b> aplikacja webowa będzie niedostępna w dniu dzisiejszym od godziny 19:00 do 21:00. </b>
      Za wszelkie utrudnienia i niedogodności przepraszamy. <br />
      W razie jakichkolwiek pytań lub wątpliwości, prosimy o kontakt mail:
      <a href="mailto:techsupport@fliko.pl">techsupport&commat;fliko.pl</a>
    </div> -->
    <app-switch-context
      [estateControl]="estateControl"
      [contextType]="contextType"
      [contextData]="contextData"
      [estates]="estates"
    ></app-switch-context>
    <app-select-input
      *ngIf="contextType === CT.ESTATE"
      prefixIcon="location_city"
      [formControl]="estateControl"
      [options]="estateOptions"
      [outline]="false"
      [placeholderKey]="('label.search' | loc) + '...'"
      [searchable]="estateOptions.length > 5"
      [footer]="false"
    ></app-select-input>
    <mat-divider class="vertical-divider" [vertical]="true"></mat-divider>
    <button
      mat-icon-button
      type="button"
      class="browser-ntf-trigger"
      (click)="showBrowserNotifications()"
      [matTooltip]="'browserNtf.panel.title' | loc"
    >
      <mat-icon>notifications</mat-icon>
      <span class="unread-counter" *ngIf="unreadNotificationsCount">{{ unreadNotificationsLabel }}</span>
    </button>
    <mat-divider class="vertical-divider" [vertical]="true"></mat-divider>
    <app-user-actions></app-user-actions>
    <mat-divider class="vertical-divider" [vertical]="true"></mat-divider>
    <app-language-select></app-language-select>
  </div>

  <button class="mat-stroked-button other-actions mobile" *ngIf="rwdService.isSmallDevice" (click)="showMobileActions()">
    <mat-icon class="padded-icon">settings</mat-icon>
    {{ 'button.moreActions' | loc }}
  </button>
</div>
<mat-divider></mat-divider>
